import { render } from "./PageHeader.vue?vue&type=template&id=416cc4e0"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script